import React from "react";

const variants = {
  primary: "bg-accent text-text-inverse hover:bg-accent-hover focus:ring-accent",
  secondary: "bg-transparent border border-border text-text-primary hover:bg-bg-sunken focus:ring-accent",
  ghost: "bg-transparent text-text-secondary hover:bg-bg-sunken hover:text-text-primary focus:ring-accent",
  destructive: "bg-error text-white hover:bg-red-700 focus:ring-error",
  "destructive-ghost": "bg-transparent border border-error/30 text-error hover:bg-error-subtle focus:ring-error",
};

const sizes = {
  sm: "min-h-[32px] px-3 py-1 text-sm",
  default: "min-h-button px-4 py-2 text-base",
  lg: "min-h-[44px] px-5 py-2.5 text-lg",
};

function Spinner({ className }) {
  return (
    <svg className={`animate-spin h-4 w-4 ${className || ""}`} viewBox="0 0 24 24" fill="none">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

function Button({
  onClick,
  type = "button",
  label,
  pending,
  loadingLabel,
  variant = "primary",
  size = "default",
  ghost,
  className = "",
  disabled,
  children,
  icon: Icon,
  iconOnly = false,
}) {
  const resolvedVariant = ghost ? "destructive-ghost" : variant;

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={pending || disabled}
      className={[
        "inline-flex items-center justify-center gap-2 font-medium rounded-sm",
        "transition-all duration-fast",
        "focus:outline-none focus:ring-2 focus:ring-offset-1",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variants[resolvedVariant] || variants.primary,
        iconOnly ? "!px-2 !min-w-[36px]" : sizes[size] || sizes.default,
        pending && "cursor-wait",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {pending && <Spinner />}
      {!pending && Icon && <Icon size={18} strokeWidth={1.5} />}
      {iconOnly ? null : pending ? loadingLabel || label : children || label}
    </button>
  );
}

export default Button;
export { Spinner };
